import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
/* eslint-disable sort-keys */
export const CFBaseIconTokens = {
    ANIMATION_DURATION: 100,
    COLORS: {
        FILL: 'text-and-element-default',
    },
    SIZES: {
        xxs: 12,
        xs: 16,
        sm: 20,
        md: 24,
        lg: 32,
        xl: 40,
        xxl: 48,
    },
};
/* eslint-enable sort-keys */
//
// Helpers
//
export const CFBaseIconHelpers = {
    color: ({ $color = CFBaseIconTokens.COLORS.FILL }) => {
        return CFTokens.getCFColorValue($color, $color);
    },
    size: ({ size = 'md' }) => CFBaseIconUtils.getSize(size),
};
export const CFBaseIconUtils = {
    getSize: (size = 'md') => {
        if (typeof size === 'number')
            return size;
        if (size && Object.keys(CFBaseIconTokens.SIZES).includes(size))
            return CFBaseIconTokens.SIZES[size];
        return CFBaseIconTokens.SIZES.md;
    },
};
//
// Element Styles
//
export const CFBaseIconStyles = {
    IconSVG: css `
    width: 100%;
    height: 100%;
    fill: ${CFBaseIconHelpers.color};
  `,
    Wrapper: css `
    width: ${CFBaseIconHelpers.size}px;
    height: ${CFBaseIconHelpers.size}px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
    WrapperWeb: css `
    transition-property: width, height;
    transition-duration: ${CFBaseIconTokens.ANIMATION_DURATION}ms;
    transition-timing-function: ease-in;
  `,
};
